const YASH_HUBSPOT_MEETING_LINK = 'https://meetings.hubspot.com/ycee/strategy-session';

const JESS_HUBSPOT_MEETING_LINK = 'https://meetings.hubspot.com/jessica-beckett/strategy-session';

const JIM_HUBSPOT_MEETING_LINK = 'https://meetings.hubspot.com/jim-tanevski';

const JIM_HUBSPOT_STRATEGY_MEETING_LINK = 'https://meetings.hubspot.com/jim-tanevski/trial-wins-workshop';

export {
  YASH_HUBSPOT_MEETING_LINK,
  JESS_HUBSPOT_MEETING_LINK,
  JIM_HUBSPOT_MEETING_LINK,
  JIM_HUBSPOT_STRATEGY_MEETING_LINK,
};
